var $root = $('html, body');

$('a[href^="#"].smooth-scroll').click(function () {
    var href = $.attr(this, 'href');
    if (href.length > 1) {
        $root.animate({
            scrollTop: $(this.hash).offset().top
        }, 500, function () {
            window.location.hash = href;
        });
    }
});